import React, { Component, Fragment } from 'react';
import Classname from 'classnames';
import { ReactComponent as Back } from 'Icons/back-bordered.svg';
import { ReactComponent as Forward } from 'Icons/forward-bordered.svg';
import { ReactComponent as FilterIcon } from 'Icons/filter.svg';
import Dropdown from 'Components/Dropdown';
import MultipleDropdown from 'Components/MultipleDropdown';
import ClickOutside from 'Components/ClickOutside'
import Upload from 'Components/Upload';
import { RFQ_PROV_DISPLAY_LIMIT , BAGS_LOAD, CARGIL, LOI_STATUS, GREEN_PLY, ARDEX } from 'Constants/commonConstants';
import Cx from 'classnames';
import Input from 'Components/Input';
import { isAdaniWilmar, isVishaka } from 'Utils/';
import { debounce, getUser } from 'Utils/storage';

const allocationTypes = [
   {value: 1, label: 'Allocation'},
   {value: 2, label: 'Non-Allocation'}
]

class TripTableHeader extends Component {
   constructor(props) {
      super(props);
      this.state = {
         searchText: "",
         vehicleType: "",
         from: props.isCp ? [] : '',
         to:  props.isCp ? [] : '',
         vehicleBodyType: "",
         isFiltersShown: false,
         offset: props.offset || 0,
         tripsWithBidding: false,
         tripsWithoutBidding: false,
         tripsWithdrawBid: false,
         tripsToFetch: 1,
         zoneFrom: "",
         zoneTo: "",
         movementType: "",
         modeType: "",
         slab: "",
         tZone :"",
         plantName:"",
         materialName:"",
         distName:"",
         tripsSingleBidding: false,
         tripsMinmumBidding: false,
         isBags: 0,
         tripsWithCP: false,
         loiStatus: undefined
      }
      this.viewMode = props.viewMode;
      this.debouncedSearchForTransporter= debounce(this.searchForTransporter, 800);
   }
   getFilters = () => {
      return {
         vehicle_type: this.state.vehicleType,
         // vehicle_body_type: this.state.vehicleBodyType,
         from: this.state.from,
         to: this.state.to,
         search: this.state.searchText,
         offset: this.state.offset,
         limit: this.props.isCp ? 1000 : RFQ_PROV_DISPLAY_LIMIT, //1000,
         tripsToFetch: this.state.tripsToFetch,
         zoneFrom: this.state.zoneFrom,
         zoneTo: this.state.zoneTo,
         movementType: this.state.movementType,
         modeType: this.state.modeType,
         slab: this.state.slab,
         tZone : this.state.tZone,
         plantName : this.state.plantName,
         materialName: this.state.materialName,
         distName : this.state.distName,
         isBags : this.state.isBags,
         tripsWithdrawBid: this.state.tripsWithdrawBid && 1 || undefined,
         loiStatus: this.state.loiStatus,
         transporterId: this.state.transporterId
      };
   }
   clearSearch = () => {
      this.setState({ searchText: '' }, () => {
         this.props.fetchTrips(this.getFilters(), true)
      })
   }
   applyFilter = () => {
      this.props.fetchTrips(this.getFilters(), true)
   }
   tripsWithBidding = (e) => {
      this.setState({
         tripsWithBidding: e.target.checked,
         tripsWithCP: false
      });

      if (e.target.checked && this.state.tripsWithoutBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else if (!e.target.checked && !this.state.tripsWithoutBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else {
         if (e.target.checked) {
            this.setState({
               tripsToFetch: 2
            }, this.applyFilter);
            this.setState({ tripsToFetch: 2 });
         }
         else {
            this.setState({
               tripsToFetch: 3
            }, this.applyFilter);
         }
      }
   }
   tripsWithoutBidding = (e) => {
      this.setState({
         tripsWithoutBidding: e.target.checked,
         tripsWithCP: false
      });

      if (e.target.checked && this.state.tripsWithBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else if (!e.target.checked && !this.state.tripsWithBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else {
         if (!e.target.checked) {
            this.setState({
               tripsToFetch: 2
            }, this.applyFilter);
            this.setState({ tripsToFetch: 2 });
         }
         else {
            this.setState({
               tripsToFetch: 3
            }, this.applyFilter);
         }
      }
   }
   tripsSingleBidding = (e) => {
      this.setState({
         tripsSingleBidding: e.target.checked
      });

      if (e.target.checked && this.state.tripsMinmumBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else if (!e.target.checked && !this.state.tripsMinmumBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else {
         if (e.target.checked) {
            this.setState({
               tripsToFetch: 5
            }, this.applyFilter);
            this.setState({ tripsToFetch:  5});
         }
         else {
            this.setState({
               tripsToFetch: 4
            }, this.applyFilter);
         }
      }
   }
   tripsMinmumBidding = (e) => {
      this.setState({
         tripsMinmumBidding: e.target.checked
      });

      if (e.target.checked && this.state.tripsSingleBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else if (!e.target.checked && !this.state.tripsSingleBidding) {
         this.setState({
            tripsToFetch: 1
         }, this.applyFilter);
      }
      else {
         if (!e.target.checked) {
            this.setState({
               tripsToFetch: 5
            }, this.applyFilter);
            this.setState({ tripsToFetch: 5 });
         }
         else {
            this.setState({
               tripsToFetch: 4
            }, this.applyFilter);
         }
      }
   }
   clearFilter = (e) => {
      this.setState({
         isFiltersShown: false,
         [e.target.getAttribute('name')]: "",
         offset: 0
      }, this.applyFilter);
   }
   searchTrips = (e) => {
      this.setState({
         searchText: e.target.value,
         offset: 0
      }, this.applyFilter)
   }
   setFilter = (value, filterName) => {
      this.setState({
         [filterName]: filterName === 'slab' ? value.slab : ((this.props.isCp && (filterName === 'from' || filterName === 'to')) ? [...this.state[filterName], value.value] : (value.value || value.id)),
         offset: 0
      }, () => {
         if(!this.props.isCp)
         this.applyFilter()
      })
   }
   fetchNextTrips = () => {
      const { offset } = this.state;
      const { tripsCount } = this.props;
      if (tripsCount && (tripsCount > (offset + RFQ_PROV_DISPLAY_LIMIT))) {
         this.setState({
            offset: this.state.offset + RFQ_PROV_DISPLAY_LIMIT
         }, () => {
            this.props.fetchTrips(this.getFilters());
         });
      }
   }
   fetchPreviousTrips = () => {
      const { offset } = this.state;
      const { tripsCount } = this.props;
      if (offset > 0) {
         this.setState({
            offset: this.state.offset - RFQ_PROV_DISPLAY_LIMIT
         }, () => {
            this.props.fetchTrips(this.getFilters());
         });
      }
   }
   showFilters = () => {
      this.setState({
         isFiltersShown: true
      }, () => {
         if(this.props.getVehicleTypes) {
            this.props.getVehicleTypes();
         }
         if(this.props.getSeekerTransporters) {
            this.props.getSeekerTransporters({});
         }
      })
   }
   hideFilters = () => {
      this.setState({
         isFiltersShown: false
      })
   }

   onChange = (file) => {
      this.props.uploadTrips(file);
   }

   onSlabChange = (e) => {
      const { name, value } = e.target
      this.setState({
         [name] : value
      }, this.applyFilter)
   }

   deselect = (item, key) =>  {
     const result = (this.state[key] || []).filter(el => el.value === item.value);
     this.setState({
        [key]: result
     });
   }

   getBiddingSolutionValue = () => {
      const { acceptPartialSolution, biddingPercentageSolution, companyId } = this.props;
      const isVishakaCompany = isVishaka(companyId);
      let biddingSolutionValue = isVishakaCompany ? 'Part Bidding' : 'Partial Solution';
      if(biddingPercentageSolution) {
         biddingSolutionValue = 'Percentage Solution';
      } else if(!acceptPartialSolution) {
         biddingSolutionValue = isVishakaCompany ? 'Package Bidding' : 'Complete Solution';
      }
      return biddingSolutionValue;
   }


   searchForTransporter=(searchText)=>{
      if((searchText).length >= 3||searchText ==""){
         this.props.getSeekerTransporters({
            search:searchText
         });
      }
    }
    

   onChangeSearchForTransporter = (searchText)=>{
    this.debouncedSearchForTransporter(searchText)
   }

   render() {
      const {
         tripsCount,
         vehicleTypes,
         vehicleBodyTypes,
         header,
         searchPlaceholder,
         countText,
         disableAddTrip,
         showLocationFilters,
         allLocations,
         isCp,
         includesOtherCharges,
         rfqType,
         acceptPartialSolution,
         bidCompletedCount,
         bidPendingCount,
         secondaryContractType,
         rfqServiceType,
			rfqDetails,
			courierTatWeight,
			courierPriceWeight,
         courierZones,
         courierMovements,
         courierModes,
         isCourierFilter,
         slabList,
         couriertripsCount,
         fromZones,
         toZones,
         addingTrip,
         sftpAllocationType,
         sftpType,
         rfqTypeLtc,
         LTC,
         tZones,
			plantNames,
			materials,
         enabledObdsFilter,
         distNames,
         sendLoiType,
         isChallengePriceForm,
         companyId,
         withPincode,
         transporters,
         isShowTransporter
      } = this.props;
      const user = getUser();
      const { offset, tripsWithBidding, tripsWithoutBidding, tripsWithdrawBid, tripsSingleBidding, tripsMinmumBidding, tripsWithCP} = this.state;
      const isShowFilters = (rfqType === 6) ? !addingTrip : true;
      let fromLocations = [];
      let toLocations = [];
      if (allLocations && Object.keys(allLocations).length > 0) {
         fromLocations = allLocations.from || [];
         toLocations = allLocations.to || [];
      }

      const isCargil = CARGIL.includes(user.companyId);
      console.log('transporters', transporters);
      // console.log(rfqType + " rfq")
      return (
         <Fragment>
         {isShowFilters &&
         <div className={Cx("flex flex-middle flex-between", {
            'mb-30': (!rfqDetails || (rfqDetails && rfqDetails.serviceType !== 3))
         })}>
            
            <div className={Classname("fBold fs-22", { "flex-1": isCp })}>
               <span className="mr-10">{header || (isShowFilters && `${rfqType == 9 ? 'Lane' : 'Trip'} Details` || 'Add Trip')}</span>
               <br/>
               
               {tripsCount > 0 && !isCp && isShowFilters && <span className="fs-12 fSemibold caption-color">
                  Showing {offset + 1} To 
                                {
                     (offset + RFQ_PROV_DISPLAY_LIMIT) < tripsCount ? (offset + RFQ_PROV_DISPLAY_LIMIT) : tripsCount
                     // tripsCount
                    
                  }
               </span>
               }
              
            </div>
              {sendLoiType  && user && (user.isAccessNewFeature || []).includes('show_sftp_dropdown') && 
                        <Dropdown
                             className="wt-200 mr-20"
                              onSelect={this.props.selectSendLOIType}
                              items ={sendLoiType}
                              selectedItem={sendLoiType.find((type) => {
                                 return type.value === this.props.loiType
                              })}
                              name="loiType"
                              label="Select Send LOI Type"
                              displayKey="name"
                        />}

                   {sftpAllocationType  && user && (user.isAccessNewFeature || []).includes('show_sftp_dropdown') && <Dropdown
                             className="wt-200 mr-20"
                              onSelect={this.props.selectSftpAllcationType}
                              // add condition here for LTC
                              items={LTC === "LTC" ? [...sftpAllocationType].slice(0,-1) :  [...sftpAllocationType]}
                              selectedItem={sftpAllocationType.find((type) => {
                                 return type.value === this.props.sftpType
                              })}
                              name="sftpType"
                              label="Select Sftp Type"
                              displayKey="name"
                        />}

                     {isCp && 
                        <Dropdown
                             className="wt-200 mr-20"
                              onSelect={this.props.setAllocationType}
                              items ={allocationTypes}
                              selectedItem={allocationTypes.find((type) => {
                                 return type.value === this.props.selectedAllocationType
                              })}
                              name="allocationType"
                              label="Select Allocation"
                              displayKey="label"
                              canClear={true}
                              onClear={this.props.clearAllocation}
                        />}
                        
            {!tripsCount && rfqDetails && rfqDetails.serviceType===3 && isShowFilters  && <div><spn class="bg-gray ht-25 flex flex-middle pl-15 pr-15 br-5 pr-1 fSemibold fs-16 header-medium-color">{couriertripsCount} {countText}</spn></div>}
            {
               !isCp && rfqServiceType !== 3 && isShowFilters &&
               <div className="flex flex-middle">
                  {rfqType !== 9 && <span className="clearable">
                     <input placeholder={searchPlaceholder || "Search Trips"}
                        type="text"
                        className="mr-30 wt-200 br-20 ht-40 bg-gray search"
                        value={this.state.searchText}
                        onChange={this.searchTrips}
                     />
                     {this.state.searchText && this.state.searchText.length > 0 &&
                        <span
                           className="clearable__clear"
                           onClick={() => {
                              this.setState({ searchText: "" }, () => { this.clearSearch(); });
                           }}
                        >&times;</span>
                     }
                  </span>}
                  {
                     this.props.showPagination !== false && isShowFilters &&
                     <React.Fragment>
                        <Back className={Classname("mr-20", {
                           'fill-gray stroke-rect-gray': offset === 0,
                           'fill-theme stroke-rect-theme curP': offset > 0
                        })} onClick={this.fetchPreviousTrips} />
                        <Forward className={Classname("mr-20", {
                           'fill-gray stroke-rect-gray': tripsCount <= (offset + RFQ_PROV_DISPLAY_LIMIT),
                           'fill-theme stroke-rect-theme curP': tripsCount > offset + RFQ_PROV_DISPLAY_LIMIT
                        })} onClick={this.fetchNextTrips} />
                        {tripsCount > 0 && <span className="fs-12 fSemibold caption-color">
                           Showing {offset + 1} To {' '}
                           {
                              (offset + RFQ_PROV_DISPLAY_LIMIT) < tripsCount ? (offset + RFQ_PROV_DISPLAY_LIMIT) : tripsCount
                              // tripsCount
                           }
                        </span>
                        }
                     </React.Fragment>
                  }
               </div>
            }
					{(rfqServiceType === 3 && courierTatWeight && courierPriceWeight) && <span className="fSemibold fs-16 theme-color">TAT Weightage - {Number(courierTatWeight)}% | Price Weightage - {courierPriceWeight}%</span>}
				{(rfqType === 3) && secondaryContractType && <div>
               {secondaryContractType === 1 ? <span className="fBold fs-14 theme-color">*{['999', '872'].includes(companyId) ? 'Dedicated' : 'Adhoc'}</span> : <span className="fBold fs-14 theme-color">*{['999', '872'].includes(companyId) ? 'Slab Wise' : 'Long Term'}</span>}
            </div>}
            {(rfqType === 2 || rfqType === 3 || rfqType === 5) && <div>
               {includesOtherCharges === true ? <span className="fBold fs-14 theme-color">*Includes</span> : <span className="fBold fs-14 theme-color">*Excludes</span>}
            </div>}
				{((rfqType === 2 || rfqType === 1 || rfqType === 3 || rfqType === 5) && (rfqServiceType !== 3)) && (acceptPartialSolution && acceptPartialSolution!==undefined || !acceptPartialSolution && acceptPartialSolution!==undefined ) &&<div className="ml-5">
               <span className="fBold fs-14 theme-color">{`* ${this.getBiddingSolutionValue()}`}</span>
            </div>}
            {(( rfqType === 1 ) ) && (rfqTypeLtc && rfqTypeLtc!==undefined ) &&<div className="ml-5">
               {rfqTypeLtc ? <span className="fBold fs-14 theme-color">*{rfqTypeLtc}</span> : <span className="fBold fs-14 theme-color"></span>}
            </div>}
            {(rfqType === 2 || rfqType === 1 || rfqType === 5) && <div>
               {!acceptPartialSolution && <span className="fSemibold fs-16"><span className="success-color fSemibold fs-16">{bidCompletedCount}</span> {bidPendingCount >=0 && <span> | </span>}<span className="error-color fSemibold fs-16">{bidPendingCount}</span></span>}
            </div>}
            {isShowFilters && <div className="flex flex-middle">
               {tripsCount >= 0 && <div className="bg-gray ht-25 flex flex-middle pl-15 pr-15 br-5 pr-1 fSemibold fs-16 header-medium-color"> {tripsCount} {countText || 'Trips Added'}</div>}
            </div>}
            {(!isCp && this.viewMode) && ![8, 9].includes(rfqType) &&  <div className="table-text-color op-79 inBlock fs-14">
               <input
                  type="checkbox"
                  onChange={(e) => { e.stopPropagation(); this.tripsWithBidding(e) }}
                  checked={tripsWithBidding}
               // disabled={true} 
               />
               Trips With Bidding {'    '}
               {!(rfqTypeLtc && !acceptPartialSolution) &&<>
               <input
                  type="checkbox"
                  onChange={(e) => { e.stopPropagation(); this.tripsWithoutBidding(e) }}
                  checked={tripsWithoutBidding}
               // disabled={true} 
               />
               Trips Without Bidding
               </>}
               {(isChallengePriceForm || isCargil) && <>{'    '}
                  <input
                     type="checkbox"
                     onChange={(e) => { e.stopPropagation(); this.setState({ tripsWithdrawBid: e.target.checked }, this.applyFilter) }}
                     checked={tripsWithdrawBid}
                  />
                  Bid WithDrawn
               </>}
               {
                  isCargil && 
                  <>
                     <>{'    '}
                        <input
                           type="checkbox"
                           onChange={(e) => { e.stopPropagation(); this.setState({ tripsWithCP: e.target.checked, tripsWithBidding: false, tripsWithoutBidding: false.valueOf, tripsToFetch: e.target.checked ? 6 : 1 }, this.applyFilter) }}
                           checked={tripsWithCP}
                        />
                           Trips With CP
                     </>
                     <>{'    '}
                        <input
                           type="checkbox"
                           onChange={(e) => { e.stopPropagation(); this.setState({ tripsWithCP: false, tripsWithBidding: false, tripsWithoutBidding: false.valueOf, tripsToFetch: e.target.checked ? 7 : 1 }, this.applyFilter) }}
                           checked={this.state.tripsToFetch == 7}
                        />
                           Trips Without CP
                     </>
                  </>
               }
               {isAdaniWilmar() && 
               <input
                  type="checkbox"
                  onChange={(e) => { e.stopPropagation(); this.tripsSingleBidding(e) }}
                  checked={tripsSingleBidding}
               // disabled={true} 
               />
               }
               {  isAdaniWilmar() && <span>Trips Single Bids {'    '}</span>}
               { isAdaniWilmar() &&
               <input
                  type="checkbox"
                  onChange={(e) => { e.stopPropagation(); this.tripsMinmumBidding(e) }}
                  checked={tripsMinmumBidding}
               // disabled={true} 
               />}
               {  isAdaniWilmar() && <span>Trips Multiple Bids </span>}
                 </div>
            }
            <div>
            <div className="flex flex-middle pr">
               {!this.viewMode && isShowFilters && <a className="ht-25 br-20 white-color bg-theme fs-14 fSemibold pl-15 pr-15 lh-18 mr-20" onClick={this.props.downloadTrips} href={this.props.downloadTripsUrl}>Download Template</a>}
               {!this.viewMode && isShowFilters && <Upload onChange={this.onChange} value="Upload File">
                  <button className="flex flex-center flex-middle ht-25 br-20 theme-color border-theme fs-14 fSemibold pl-15 pr-15 mr-20 lh-17">Upload Excel</button>
               </Upload>
               }
               {/* {!this.viewMode && <button className="rfqExcelFileUpload"><label htmlFor="upload-trip" className="flex flex-center flex-middle ht-25 br-20 theme-color border-theme fs-14 fSemibold pl-15 pr-15 mr-20 lh-17">Upload Excel</label></button>} */}
               {GREEN_PLY.includes(user.companyId) && !this.viewMode && disableAddTrip && rfqServiceType !== 3 && ![9].includes(rfqType) && isShowFilters && withPincode !== 1 && <button className="ht-25 br-20 white-color bg-theme fs-14 fSemibold pl-15 pr-15 lh-18 mr-20" onClick={this.props.showAddTrip}>+ Add New Trip</button>}
               {!this.viewMode && !disableAddTrip && rfqServiceType !== 3 && ![9].includes(rfqType) && isShowFilters && withPincode !== 1 && <button className="ht-25 br-20 white-color bg-theme fs-14 fSemibold pl-15 pr-15 lh-18 mr-20" onClick={this.props.showAddTrip}>+ Add New Trip</button>}
               {rfqServiceType !== 3 && isShowFilters && ![9, 8].includes(rfqType) && <FilterIcon className="curP" onClick={this.showFilters} />}
               {this.state.isFiltersShown &&
                  <ClickOutside handleClickOutside={this.hideFilters}>
                     <div className="pa box-shadow bg-white br-5 wt-300 r-0 t-100p pv-25 ph-20 z-3 mt-20">
                        <div className="mb-20" >
                           <div className="fs-16 mb-5 flex flex-middle flex-between">
                              <div className="header-dark-color fSemibold">By Vehicle</div>
                              <div className="theme-color fSemibold fs-14 curP" name="vehicleType" onClick={this.clearFilter}>Clear</div>
                           </div>
                           <Dropdown
                              onSelect={this.setFilter}
                              items={vehicleTypes}
                              selectedItem={vehicleTypes.find((vehicleType) => {
                                 return vehicleType.value === this.state.vehicleType
                              })}
                              name="vehicleType"
                              label="Select Vehicle Type"
                              displayKey="name"
                              searchEnabled={true}
                              searchPlaceholder={'Search Vehicle types'}
                           />
                        </div>
                        {isShowTransporter && <div className="mb-20" >
                           <div className="fs-16 mb-5 flex flex-middle flex-between">
                              <div className="header-dark-color fSemibold">Transporters</div>
                              <div className="theme-color fSemibold fs-14 curP" name="transporterId" onClick={this.clearFilter}>Clear</div>
                           </div>
                           <Dropdown
                              onSelect={this.setFilter}
                              items={transporters}
                              selectedItem={transporters.find((trans) => {
                                 return trans.id === this.state.transporterId
                              })}
                              name="transporterId"
                              label="Select..."
                              displayKey="name"
                              searchEnabled={true}
                              searchPlaceholder={'Search..'}
                              searchEnabledForAPI = {true}
                              onChangeSearchForAPI = {this.onChangeSearchForTransporter}
                           />
                        </div>}
                        <div className="mb-20" >
                           <div className="fs-16 mb-5 flex flex-middle flex-between">
                              <div className="header-dark-color fSemibold">LOI Status</div>
                              <div className="theme-color fSemibold fs-14 curP" name="loiStatus" onClick={this.clearFilter}>Clear</div>
                           </div>
                           <Dropdown
                              onSelect={this.setFilter}
                              items={LOI_STATUS}
                              selectedItem={LOI_STATUS.find((loi) => {
                                 return loi.value === this.state.loiStatus
                              })}
                              name="loiStatus"
                              label="Select..."
                              displayKey="name"
                              searchEnabled={true}
                              searchPlaceholder={'Search..'}
                           />
                        </div>
                        {
                           showLocationFilters &&
                           <React.Fragment>
                              <div className="mb-20" >
                                 <div className="fs-16 mb-5 flex flex-middle flex-between">
                                    <div className="header-dark-color fSemibold">From</div>
                                    <div className="theme-color fSemibold fs-14 curP" name="from" onClick={this.clearFilter}>Clear</div>
                                 </div>
                                 {isCp ? <MultipleDropdown
                                    onSelect={this.setFilter}
                                    items={(fromLocations || [])}
                                    selectedItems={(fromLocations || []).filter((location) => {
                                       return this.state.from.includes(location.value)
                                    })}
                                    deselect={(item) => this.deselect(item, 'from')}
                                    name="from"
                                    label="Select Source Location"
                                    displayKey="name"
                                    searchEnabled={true}
                                    searchPlaceholder={'Search Source Location'}
                                    className="br-5 wt-auto fs-12 bg-white"
                                    isMinHeight={true}
                                    isMinWidth
                                 /> : <Dropdown
                                    onSelect={this.setFilter}
                                    items={(fromLocations || [])}
                                    selectedItem={(fromLocations || []).find((location) => {
                                       return location.value === this.state.from
                                    })}
                                    name="from"
                                    label="Select Source Location"
                                    displayKey="name"
                                    searchEnabled={true}
                                    searchPlaceholder={'Search Source Location'}
                                 />}
                              </div>
                              <div className="mb-20" >
                                 <div className="fs-16 mb-5 flex flex-middle flex-between">
                                    <div className="header-dark-color fSemibold">To</div>
                                    <div className="theme-color fSemibold fs-14 curP" name="to" onClick={this.clearFilter}>Clear</div>
                                 </div>
                                 {isCp ? <MultipleDropdown
                                    onSelect={this.setFilter}
                                    items={(toLocations || [])}
                                    selectedItems={(toLocations || []).filter((location) => {
                                       return this.state.to.includes(location.value)
                                    })}
                                    deselect={(item) => this.deselect(item, 'to')}
                                    name="to"
                                    label="Select Destination"
                                    displayKey="name"
                                    searchEnabled={true}
                                    searchPlaceholder={'Search By Destination'}
                                    className="br-5 wt-auto fs-12 bg-white"
                                    isMinHeight={true}
                                    isMinWidth
                                 /> : 
                                 <Dropdown
                                    onSelect={this.setFilter}
                                    items={(toLocations || [])}
                                    selectedItem={(toLocations || []).find((location) => {
                                       return location.value === this.state.to
                                    })}
                                    name="to"
                                    label="Select Destination"
                                    displayKey="name"
                                    searchEnabled={true}
                                    searchPlaceholder={'Search By Destination'}
                                 />}
                              </div>
                              {isCp && <button className="ht-25 br-5 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20" onClick={this.applyFilter}>Apply Filter</button>}
                           </React.Fragment>
                        }
                        {/* <div className="">
                            <div className="fs-16 mb-5 flex flex-middle flex-between">
                                <div className="header-dark-color fSemibold">By body</div>
                                <div className="theme-color fSemibold fs-14 curP" name="vehicleBodyType" onClick={this.clearFilter}>clear</div>
                            </div>
                            <Dropdown 
                                onSelect={this.setFilter}
                                items={vehicleBodyTypes} selectedItem={vehicleBodyTypes.find((vehicleBodyType)=> {
                                    return vehicleBodyType.value === this.state.vehicleBodyType
                                })}
                                name="vehicleBodyType"
                                label="Select body" 
                                displayKey="name"
                            />
                        </div> */}
                     </div>
                  </ClickOutside>
               }
               </div>
                  {(isAdaniWilmar() || GREEN_PLY.includes(user.companyId) || ARDEX.includes(user.companyId)) && !this.viewMode &&
                  <div className="error-color fs-14 fSemibold mt-5">{'Please Download The Excel Template To Get The Latest System Suggested Prices'}</div>
               }
            </div>
            <Upload id={"upload-trip"} onChange={this.props.uploadTrips} />
         </div>
         }
         {
            rfqDetails && rfqDetails.serviceType === 3 && !isCourierFilter &&
               <div className={"flex flex-middle flex-between mt-10"}>
                  <Dropdown
                     onSelect={this.setFilter}
                     items={(fromZones || [])}
                     selectedItem={(fromZones || []).find((zone) => {
                        return zone.value === this.state.zoneFrom
                     })}
                     name="zoneFrom"
                     label="Select From Zone"
                     displayKey="name"
                     className="wt-200 z-5"
                     canClear={true}
                  />
                  <Dropdown
                     onSelect={this.setFilter}
                     items={(toZones || [])}
                     selectedItem={(toZones || []).find((zone) => {
                        return zone.value === this.state.zoneTo
                     })}
                     name="zoneTo"
                     label="Select To Zone"
                     displayKey="name"
                     className="wt-200 z-5"
                     canClear={true}
                  />
                  <Dropdown
                     onSelect={this.setFilter}
                     items={(courierMovements || [])}
                     selectedItem={(courierMovements || []).find((movement) => {
                        return movement.value === this.state.movementType
                     })}
                     name="movementType"
                     label="Select Movement Type"
                     displayKey="name"
                     className="wt-250 z-5"
                     canClear={true}
                  />
                  <Dropdown
                     onSelect={this.setFilter}
                     items={(courierModes || [])}
                     selectedItem={(courierModes || []).find((mode) => {
                        return mode.value === this.state.modeType
                     })}
                     name="modeType"
                     label="Select Mode Type"
                     displayKey="name"
                     className="wt-200 z-5"
                     canClear={true}
                  />
                  <Dropdown 
                     onSelect={this.setFilter}
                     items={slabList} 
                     selectedItem={(slabList || []).find((sbList)=> {
                        return sbList.slab === this.state.slab
                     })}
                     name="slab"
                     label="Select Slab" 
                     displayKey="slab"
                     canClear={true}
                     className="wt-200 z-5"
                  />
               </div>}
         { enabledObdsFilter &&
            <div className={"flex mt-10"}>
          <Dropdown
               onSelect={this.setFilter}
               items={(plantNames || [])}
               selectedItem={(plantNames || []).find((plant) => {
                  return plant.value === this.state.plantName;
               })}
               name="plantName"
               label="Select Plant Name"
               displayKey="name"
               className="wt-250 z-5"
               canClear={true}
            />
            
            <Dropdown
               onSelect={this.setFilter}
               items={(tZones || [])}
               selectedItem={(tZones || []).find((zone) => {
                  return zone.value === this.state.tZone;
               })}
               name="tZone"
               label="Select T Zone"
               displayKey="name"
               className="wt-250 z-5 ml-35"
               canClear={true}
            />
            
            <Dropdown
               onSelect={this.setFilter}
               items={(materials || [])}
               selectedItem={(materials || []).find((material) => {
                  return material.value === this.state.materialName;
               })}
               name="materialName"
               label="Select Material Name"
               displayKey="name"
               className="wt-250 z-5 ml-35"
               canClear={true}
            />
            <Dropdown
               onSelect={this.setFilter}
               items={(distNames || [])}
               selectedItem={(distNames || []).find((dist) => {
                  return dist.value === this.state.distName;
               })}
               name="distName"
               label="Select Districts Name"
               displayKey="name"
               className="wt-250 z-5 ml-35"
               canClear={true}
            />
            <Dropdown
               onSelect={this.setFilter}
               items={(BAGS_LOAD || [])}
               selectedItem={(BAGS_LOAD || []).find((dist) => {
                  return dist.value === this.state.isBags;
               })}
               name="isBags"
               label="Select Bags/Bulk"
               displayKey="name"
               className="wt-250 z-5 ml-35"
               canClear={true}
            />
            </div>
         }
         </Fragment>
      )
   }
}

export default TripTableHeader;
